import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { MultiSelect } from 'primeng';
import { AutocompleteComponent } from '../autocomplete/autocomplete.component';
import { AutocompleteService } from '@core/services/autocomplete.service';

type MultiselectOption = {
  label: string;
  value: any;
  disabled?: boolean;
}

@Component({
  selector: 'app-multiselect',
  templateUrl: './multiselect.component.html'
})
export class MultiselectComponent extends AutocompleteComponent implements OnChanges {

  @ViewChild(MultiSelect, { static: false }) multiselectElement?: MultiSelect;

  @Input() selectedItemsLabel = 'itens selecionados';
  @Input() maxSelectedLabels = 3;
  @Input() showToggleAll = false;
  @Input() virtualScroll = true;

  optionsForMultiselect: MultiselectOption[] = [];

  value: MultiselectOption[] = [];

  constructor(
    public autocompleteService: AutocompleteService
  ) {
    super(autocompleteService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.getOptions();
    this.valueChange();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customOptions']) {
      this.optionsForMultiselect = this.convertItemsMultiselect(this.customOptions);
    }
  }

  getOptions(event?: any): void {
    if (this.customOptions) {
      this.options = [...this.customOptions];
      this.optionsForMultiselect = this.convertItemsMultiselect(this.customOptions);
      return;
    }

    if (!this.url) { return; }

    this.autocompleteService
      .getForSelectFromObject(this.url, {
        [this.searchFor]: event?.query,
        ...this.params,
      })
      .subscribe((response) => {
        const filtered = response.filter(
          item => !this.forbidden.find(
            f => f && f.id.includes(item[this.key]) &&
              !f.id.includes(this.form.get(this.name)?.value?.[this.key])
          )
        );
        this.options = filtered;
        this.optionsForMultiselect = this.convertItemsMultiselect(filtered);
      });
  }

  valueChange() {
    const initialValue = this.form.get(this.name)?.value;
    if (initialValue) {
      this.value = this.convertItemsMultiselect(initialValue)?.map(x => x.value);
      if (initialValue?.length && !this.options.length && !this.url) {
        this.customOptions = initialValue;
        this.options = [...this.customOptions];
      }
    }

    this.form.get(this.name)?.valueChanges.subscribe(value => {
      this.value = this.convertItemsMultiselect(value)?.map(x => x.value);
      if (this.value?.length && !this.options.length && !this.url) {
        this.customOptions = value;
        this.options = [...this.customOptions];
      }
    });
  }

  private convertItemsMultiselect(arr?: any[]): MultiselectOption[] {
    return arr?.map(option => ({
      label: option[this.fieldName],
      value: option[this.key],
      disabled: option.disabled
    })) || [];

  }

  setFormControl(list: MultiselectOption[]) {
    const sourceList = this.customOptions || this.options;
    const formattedList = list.map(x => {
      return sourceList.find(item => item?.[this.key] === x) || null;
    });
    this.form.get(this.name)?.setValue(formattedList);
    this.onChange.emit(formattedList);
  }

}
